import "../../../resources/RTCC/css/common/gold_check_box_style.css";

export const BlackCheckBox = (props) => {
    const { onChange, className, name, value, defaultChecked, label, key } = props;

    return (
        // props.valueは必須項目、id属性になるので、値は一意
        <div className={className ? className : "checkBoxStyle"} key={key}>
            <input
                type="checkbox"
                id={name + "_" + value}
                className="checkBoxStyle gold-check-box"
                onChange={onChange}
                name={name}
                value={value}
                defaultChecked={defaultChecked} />
            <label htmlFor={name + "_" + value} style={styles.label}>{label}</label>
        </div>
    );

}
const styles = {
    label: {
        cursor: "pointer"
    },
}

